export default {
  email: 'Email',
  physicalAddress: 'Physical address',
  webSiteUrl: 'Website URL',
  loadingApplication: 'Loading Application',
  baseUrl: 'Base URL',
  redirectionUrl: 'Redirection URL',
  prefix: 'Prefix',
  pickAApplicationColor: 'Select a color for your application',
  applicationSuccessfullyUpdated: 'Application was successfully updated',
  apiKeyCopied: 'Api Key copied',
  apiKeyCopyError: 'Error copying API Key',
  changingPublicKeyWillAffectApps: 'Changing the public key will affect all applications in use. Do you want to continue?',
  apiKey: 'API Keys',
  goToApiDoc: 'Go to the API Doc',
  publicKey: 'Public Key',
  privateKey: 'Private Key',
  generate: 'Generate',
  reNewPublicKey: 'Renew public key',
  deleteInfoField: 'Delete information field',
  sureToDeleteInfoField: 'Are you sure you want to delete this information field?',
  addInfoOfPeopleOfBrand: 'Additional information about your brand people',
  sectionAddInfoPeopleOfBrandRequested: 'In this section you can add additional information that will be requested from people of your brand', // revisar
  onlyBeSeenByAppAdministrator: 'Can only by seen by the application administrator',
  canBeSeenByPeople: 'Can be seen and modify by people from their profile',
  shortTextField: 'Short text field',
  dropDownList: 'Drop-Down list',
  addNewInfoField: 'Add new information field',
  enterExtraDataId: 'Enter the extradata identifier',
  epayCoCredentials: 'Epayco Credentials',
  emailVerifyCredentials: 'Email List Verify Credentials',
  testEnvironment: 'Test Environment',
  update: 'Update',
  modifyAddInfoField: 'Modify additional information field',
  createAddInfoField: 'Create additional information field',
  fieldSuccessfullyDeleted: 'The field was successfully deleted',
  fieldName: 'Field Name',
  access: 'Access',
  addOptions: 'Add options',
  option: 'Option | Options',
  fieldSuccessfullyCreated: 'Field was successfully created',
  fieldSuccessfullyUpdated: 'Field was successfully updated',
  application: 'Application | Applications',
  addAdministrator: 'Add user',
  administratorsPerPage: 'Users per page',
  yes: 'Yes',
  no: 'No',
  loadingAdministrators: 'Loading users',
  noAdministratorsRegistered: 'No users registered',
  action: 'Action | Actions',
  publicKeyUpdated: 'Public Key was updated',
  editAdministrator: 'Edit user',
  newAdministrator: 'New user',
  selectAdministratorType: 'Select user type',
  wantAdministratorInactive: 'Do you want the user to be inactive?',
  selectAdministratorPermissions: 'Select user\'s permissions',
  addNewAdministrator: 'Add new user',
  administratorSuccessfullyCreated: 'User successfully created',
  administratorSuccessfullyUpdate: 'User successfully updated',
  wantToDeleteAdministrator: 'Do you want to delete this user?',
  deleteAdministrator: 'Delete user',
  administratorSuccessfullyDeleted: 'User successfully deleted',
  successfullyColorUpdated: 'Color successfully updated',
  creditCard: 'Credit card',
  inviteFinancier: 'Invite financier | Invite the financier',
  billing: 'Billing',
  addCreditCard: 'Add credit card',
  loadBalance: 'Load Balance',
  usage: 'Usage | Usage | The usage',
  payment: 'Payment | the payment | payments | The payments',
  paymentMethods: 'Payments Methods',
  completeBusinessDataBeforeAddingCreditCard: 'Complete your business details before adding a credit card',
  lastDigits: 'Last digits',
  cardExpirationDate: 'Expiration date',
  changeToPrincipal: 'Change to Principal',
  creditCardSuccessfullyDeleted: 'Credit card successfully deleted',
  errorDeletingCreditCard: 'An error occurred deleting your card',
  creditCardPriorityUpdated: 'Credit Cards priority updated',
  dailyUsage: 'Daily Usage',
  report: 'Report',
  recordsPerPage: 'Records per page',
  loadingRecords: 'Loading records',
  noMovementsRecords: 'There are no movements records',
  service: 'Service',
  amount: 'Amount',
  value: 'Value',
  successfullyMovementsReportDownloaded: 'Movement report was successfully downloaded',
  detailedConsumption: 'Detailed Consumption',
  approved: 'Approved | Approved',
  creditCardRechargeWithOutCharge: 'Recharge credit card without charge',
  methodOf: 'Method of',
  billCollection: 'Bill Collection',
  NoAdditionalInfoOfPayment: 'Without additional payment information',
  noPaymentsRecords: 'No Payment Records',
  invoice: 'Invoice',
  deposit: 'Deposit',
  makePayment: 'Make Payment',
  warning: 'Warning',
  rechargeToAvoidBlockingMainFunctions: 'You should recharge your account to avoid blocking your main functions',
  load: 'Load',
  enterIdCardNumber: 'Enter your ID number',
  idCardNumber: 'ID number',
  createCard: 'Create Card',
  youMustCompleteCardInformation: 'You must complete your credit card details',
  cardInformationIncorrect: 'The card details are incorrect',
  creditCardSuccessfullyAdded: 'Credit card successfully added',
  checkCardDetails: 'Check the card details',
  rejectedCard: 'The card was rejected',
  errorAddingCardPleaseTryAgain: 'Error adding card. Please try again',
  noDependencies: 'No dependencies',
  dependsOn: 'Depends On',
  journeyId: 'Journey ID',
  loadingJourneys: 'Loading Journeys',
  noJourneysForThisApp: 'No Journeys for this application',
  editJourney: 'Edit Journey',
  addNewJourney: 'Add new Journey',
  dependencies: 'Dependencies',
  selectJourneyColor: 'Select the journey color',
  chooseAColor: 'Choose a color',
  wantThisDefaultStateWhenSomeoneSignsUp: 'Do you want this to be the default state when someone signs up?',
  wantToShowThisStateOnTheSideMenu: 'Do you want to display this status in the side menu?',
  loadingJourney: 'loading Journey',
  addJourney: 'Add Journey',
  journeySuccessfullyCreated: 'Journey successfully created',
  journeySuccessfullyEdited: 'Journey successfully edited',
  yellow: 'Yellow',
  orange: 'Orange',
  red: 'Red',
  purple: 'Purple',
  darkBlue: 'Dark Blue',
  lightBlue: 'Light Blue',
  green: 'Green',
  wantToDeleteJourney: 'Do you want to delete this Journey?',
  deleteJourney: 'Delete Journey',
  journeySuccessfullyDeleted: 'Journey successfully deleted',
  clickToSearchOnTheComputer: '... or click here to search files on your computer',
  lastName: 'Last name',
  logInWith: 'Login with',
  signInWith: 'Sign in with',
  logInToYourAccount: 'Login into your account',
  signIn: 'Sign in',
  selectColor: 'Select color',
  selectLogo: 'Select logo',
  customPhrase: 'Custom phrase',
  customPhraseOnLogIn: 'Custom phrase on login',
  customPhraseOnSignIn: 'Custom phrase on sign in',
  enterSignInMode: 'Enter the sign in mode',
  customPhraseOnLogInButton: 'Custom phrase on login button',
  customPhraseOnSignInButton: 'Custom phrase on sign in button',
  hideSocialNetworks: 'hide Social Networks',
  showSignInFirst: 'Show sign in first',
  showCustomButton: 'Show custom button',
  buttonText: 'Button text',
  requestData: 'Request Data',
  defaultData: 'Default Data',
  identification: 'Identification',
  department: 'Department',
  healthProvider: 'Health provider',
  bloodType: 'blood type',
  day: 'day | days',
  month: 'month | months',
  allTheData: 'All the data',
  year: 'year | years',
  range: 'Range',
  insertTheHtmlTemplateInTheFollowingField: 'Insert the html template in the following field',
  templatePreview: 'Template Preview',
  /* Forms */
  solo: 'Solo',
  normal: 'Normal',
  needToRefreshBeforeCreateForms: 'You need to refresh before create forms',
  createForm: 'Create Form',
  formsPerPage: 'Forms per page',
  loadingForms: 'Loading Forms',
  noFormsRegistered: 'There are no registered Forms',
  formName: 'Form Name',
  insertFormOnWebSite: 'Insert form on your Website',
  personalization: 'Personalization',
  injectableCode: 'Injectable code',
  customYourFormAndInsertGeneratedCodeOnTheNextTab: 'Custom your form and then insert the generated code on the following Tab',
  style: 'Style',
  responseMessageSent: 'Response message sent',
  sendButton: 'Send Button',
  length: 'Length',
  alignment: 'Alignment',
  selectFormColor: 'Select your form color',
  divWithKeybeFormsToInsertForm: 'To insert a form to your web page, you must create a DIV element with the ID  "keybe-forms" in the body of your site ',
  andThenAddTheNextScriptToTheFooter: 'then add the following Script in the Footer of your site',
  left: 'Left',
  right: 'Right',
  center: 'Center',
  small: 'Small',
  large: 'Large',
  none: 'None',
  outlined: 'Outlined',
  filled: 'Filled',
  editForm: 'Edit form',
  registerForm: 'Register Form',
  obligateLogIn: 'Obligate login?',
  assignRoleWhenFormIsCompleted: 'Assign role when form is completed?',
  setUpNotificationsEmailForm: 'Set up an email where you will receive notifications of a form submission',
  emailSubject: 'Email Subject',
  sendEmailOnSubmit: 'Send email when receiving submit',
  sendSmsOnSubmit: 'Send SMS when receiving submit',
  fields: 'Fields',
  addField: 'Add field',
  needToSelectRegisterEmailOrPhone: 'You must select the registration email or phone',
  formSuccessfullyEdited: 'Form was successfully edited',
  fieldLength: 'Field length',
  required: 'Required',
  minFiles: 'Minimum number of files',
  linkOfTermsAndConditions: 'Link to terms and conditions',
  dataHandlingLink: 'Data handling link',
  verificationFields: 'Verification fields',
  filesUpLoad: 'Files upload',
  dataManagement: 'Data management',
  hide: 'Hide',
  multipleOption: 'Multiple choice',
  NoRestrictions: 'No restrictions',
  fullRow: 'Full row',
  halfRow: 'Half row',
  newForm: 'New form',
  addNewForm: 'Add new form',
  formSuccessfullyCreated: 'Form correctly created',
  files: 'Files',
  fileType: 'File type',
  responses: 'Responses',
  responsesPerPage: 'Responses per page',
  loadingResponses: 'Loading responses',
  noResponsesYet: 'you haven\'t received a reply yet',
  next: 'Next',
  largeTextField: 'Large text field',
  registry: 'Registry',
  creatingANewApplicationIsVerySimpleJustFillInTheInformationWeRequestToGoToTheNextStep: 'Creating a new application is very simple, just fill in the information we request to go to the next step (Set up social networks)',
  applicationName: 'Application name',
  addNewApplication: 'Create new application',
  applicationSuccessfullyCreated: 'Application was successfully created',
  saveNewBusiness: 'Save new business',
  thePageYouAreLookingForDoesNotExist: 'The page you are looking for does not exist',
  address: 'Address',
  city: 'City',
  country: 'Country',
  cellPhone: 'Cell phone number',
  documentType: 'ID Type',
  darkTheme: 'Dark theme',
  lightTheme: 'Light theme',
  sidebar: 'Sidebar',
  toolbar: 'Toolbar',
  cardNumber: 'Card number',
  money: 'Money',
  showFieldInPeopleFilters: 'Show field in people\'s filters',
  timeZoneInformation: `
  Assigning your time zone is essential so that
  the tasks that are assigned to you and the dates
  of creation and updating of data are displayed correctly.
  `
}
